<div class="wrapper">
  <div class="sidebar navbar" data-color="white" data-background-color="black" data-image="./assets/img/sidebar-forwarder.jpg">
    <app-sidebar></app-sidebar>
    <div class="sidebar-background" style="background-image: url(assets/img/sidebar-forwarder.jpg)"></div>
  </div>
  <div class="main-panel">
    <app-navbar></app-navbar>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </div>
</div>
